import React from "react";
import { Col, Container, Row } from "reactstrap";
import { DocumentsManagement } from "./DocumentsManagement";

export function Documentation() {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
            <h3 style={{ marginBottom: 30, color:"#024b82" }}>Creación y almacenamiento de documentos</h3>
        </Col>
      </Row>
      <Row>
        <DocumentsManagement />
      </Row>
    </Container>
  );
}
